const getActiveRecovery = (recoveryQueue = [], submittedProfessionalTypes = []) => {
    const submitted = new Set(submittedProfessionalTypes);
    return recoveryQueue.find((item) => !submitted.has(item.professionalType)) || null;
};

module.exports = { getActiveRecovery };
